import clsx from 'clsx';
import './BackLink.css';

export interface BackLinkProps {
  /** Visible label ("უკან"). Also the accessible name. */
  label: string;
  onPress: () => void;
  className?: string;
}

/**
 * BackLink — the minimal borderless "‹ back" affordance used at the top of
 * sub-screens (Settings, Subscription). Deliberately NOT a 3D Button: a
 * back link is chrome, not an action worth chunk.
 */
export function BackLink({ label, onPress, className }: BackLinkProps) {
  return (
    <button type="button" className={clsx('fluent-back-link', className)} onClick={onPress}>
      <span aria-hidden="true" className="fluent-back-link__glyph">
        ‹
      </span>
      {label}
    </button>
  );
}
